import { Observable } from 'knockout';
import WCCEntity from './entity';

export interface JSONVideoPresentationProgress {
    PersonId?: string
    FirstName?: string
    LastName?: string

    AttemptNumber?: number
    CurrentPosition?: number
    PreciseProgress?: number
}

export default class VideoPresentationProgress extends WCCEntity<JSONVideoPresentationProgress> {
    personId: Observable<string | undefined>
    firstName: Observable<string | undefined>
    lastName: Observable<string | undefined>

    attemptNumber: Observable<number>
    currentPosition: Observable<number>
    preciseProgress: Observable<number>

    constructor(data?: JSONVideoPresentationProgress) {
        super();

        this.personId = this.createField(data, 'PersonId');
        this.firstName = this.createField(data, 'FirstName');
        this.lastName = this.createField(data, 'LastName');

        this.attemptNumber = this.createField(data, 'AttemptNumber', 1);
        this.currentPosition = this.createField(data, 'CurrentPosition', 0);
        this.preciseProgress = this.createField(data, 'PreciseProgress', 0);
    }
}